import { ProviderMedicalRole } from '@uplift/types';
import { getMatches, getMatchAppointmentStats } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from '@uplift/queries';


type PsychiatryMatchingArgs = {
  stateId?: string;
  insuranceCompanyUuid?: string;
  patientId?: string;
};


export const usePsychiatryMatching = (args: PsychiatryMatchingArgs, opts?: BaseQueryOpts) => {
  const enabled = Boolean(args.stateId && args.patientId);
  const { data, isInitialLoading } = useQuery({
    queryKey: [ 'matches', args ],
    queryFn: async() => {
      if (enabled) {
        return await getMatches({
          seed: 0.3,
          medicalRole: ProviderMedicalRole.psychiatrist,
          insuranceCompanyId: args.insuranceCompanyUuid,
          stateId: args.stateId,
          patientId: args.patientId,
        });
      }

      return null;
    },
    enabled: enabled,
    ...opts,
  });

  return {
    matchingFetching: isInitialLoading,
    matchingProvidersType: data?.data.type,
    psychiatryData: data?.data.matchingProfiles ?? [],
  };
};


export const useMatchAppointmentStatsQuery = (matchId: string, opts?: BaseQueryOpts) => useQuery({
  queryKey: [ 'match', matchId, 'stats' ],
  queryFn: async () => {
    if (!matchId) {
      return null;
    }

    return await getMatchAppointmentStats(matchId);
  },
  select: response => response?.data,
  ...opts,
});
